"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarBox = exports.Reviews = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const canvas_box_1 = require("../canvas-box");
exports.Reviews = styled_components_1.default.a `
  width: fit-content;
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
  box-sizing: border-box;
  flex-wrap: nowrap;
  display: flex;
  flex-direction: row;
  padding: 4px 0 0 0;
  font-size: 12px;
  text-decoration-line: none;
`;
exports.StarBox = (0, styled_components_1.default)((props) => react_1.default.createElement(canvas_box_1.CanvasItem, Object.assign({}, props))) `
  width: fit-content;
`;
